import {
  Checkbox,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from "@chakra-ui/react";
import { Table } from "antd";
import { Search, X } from "lucide-react";
import React from "react";
import { useUsersSelectionTable } from "../hooks/useUsersSelectionTable";
import { UsersSelectionTableProps } from "../types/IUsersSelectionTable";

const UsersSelectionTable: React.FC<UsersSelectionTableProps> = ({
  users,
  selectedKeys,
  onSelectionChange,
  t,
  selectedUsersBar,
  disabled = false,
}) => {
  const {
    rowSelection,
    columns,
    searchTerm,
    setSearchTerm,
    handleSelectAll,
    allUsersWithWhatsApp,
    checkAll,
    filteredUsers,
  } = useUsersSelectionTable({ users, selectedKeys, onSelectionChange, t });

  return (
    <>
      <Flex justifyContent={"space-between"} alignItems={"center"} gap={4}>
        <InputGroup width="100%">
          <InputLeftElement
            pointerEvents="none"
            children={<Search size="15px" color="#717680" />}
          />
          <Input
            id="searchField"
            color="#3A3A3A"
            bg="white"
            placeholder={t("searchByUserName") as string}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e?.target?.value)}
            disabled={disabled}
          />
          {searchTerm?.length > 0 && (
            <InputRightElement
              cursor={"pointer"}
              onClick={() => setSearchTerm("")}
              children={<X size="15px" color="#717680" />}
            />
          )}
        </InputGroup>
        <Checkbox
          width={"200px"}
          isChecked={checkAll}
          disabled={
            disabled || allUsersWithWhatsApp?.hasOnlyUsersWithoutWhatsApp
          }
          onChange={(e) => handleSelectAll(e?.target?.checked)}
        >
          {t("allUsers")}
        </Checkbox>
      </Flex>
      {selectedUsersBar}
      <Table
        pagination={{ pageSize: 50, showSizeChanger: false }}
        scroll={{ y: 240 }}
        rowKey={(record) => record.userId}
        rowSelection={
          disabled ? undefined : { type: "checkbox", ...rowSelection }
        }
        columns={columns}
        dataSource={filteredUsers}
        showHeader={true}
      />
    </>
  );
};

export default UsersSelectionTable;
